export type VenueFilter = 'both' | 'lasalle' | 'serre';
export type RateCategory = 'base' | 'special' | 'high' | 'discount';

export interface DayAvailability {
  price: RateCategory;
  discount: number; // fraction: 0.2 = -20%
  venues: string[]; // subset of ['lasalle', 'serre']
}

export interface CalendarLabels {
  filterLabel: string;
  filterBoth: string;
  filterLasalle: string;
  filterSerre: string;
  legendLasalle: string;
  legendSerre: string;
  legendSelected: string;
  legendUnavailable: string;
  legendDeal: string;
  available: string;
  full: string;
  selectionCleared: string;
  emptyMonth: string;
  noteSpecial: string;
  noteDiscount: string;
  wordTable: string;
  wordSalle: string;
}

/** French fallbacks; overridden by text-store values in step-date. */
export const DEFAULT_LABELS: CalendarLabels = {
  filterLabel: 'Pour quel lieu ?',
  filterBoth: 'Les deux',
  filterLasalle: 'La Roue',
  filterSerre: 'La Serre',
  legendLasalle: 'La Roue (la Salle ou la Table)',
  legendSerre: 'La Serre disponible',
  legendSelected: 'Date sélectionnée',
  legendUnavailable: 'Date indisponible',
  legendDeal: 'Tarif réduit',
  available: 'disponible',
  full: 'complet',
  selectionCleared: "La date choisie n'est plus disponible — veuillez sélectionner une autre date.",
  emptyMonth: 'Aucune date disponible ce mois-ci',
  noteSpecial: 'Prix spécial sur certaines prestations uniquement (pas de remise globale)',
  noteDiscount: 'Remise globale de -{pct} % sur toute la réservation',
  wordTable: 'Table',
  wordSalle: 'Salle',
};

/** Corner tag: a single "€" on cheaper-than-base days, nothing otherwise. */
export function priceTag(price: RateCategory): string | null {
  return price === 'special' || price === 'discount' ? '€' : null;
}
